/**
 * Created by Andrey Popov on 26.10.2021
 */

const QuestsIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.quests_icon_json,
        control: "QuestsGroupIcon",
        targets: "questsGroupIcon"
    });

    this.activeInfoView = undefined;

    this.onGetView = function () {};

    cleverapps.eventBus.on("questProgressChanged", this.onQuestProgressChanged.bind(this));
};

QuestsIcon.prototype = Object.create(SideBarIcon.prototype);
QuestsIcon.prototype.constructor = QuestsIcon;

QuestsIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "QuestsWindow",
        stack: true,
        action: (f) => {
            new QuestsWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

QuestsIcon.prototype.onQuestProgressChanged = function (quest) {
    if (this.available) {
        this.showInfo(quest, { compact: !quest.isFinished() });
    }
};

QuestsIcon.prototype.hideInfo = function () {
    if (this.activeInfoView) {
        this.activeInfoView.hide();
        delete this.activeInfoView;
    }
};

QuestsIcon.prototype.showInfo = function (quest, options) {
    const iconView = this.onGetView();
    if (!iconView) {
        return;
    }

    this.hideInfo();
    options.iconView = iconView;
    const ViewCtor = QuestsWindow.IsAvailable() ? QuestNotificationView : QuestInfoView;
    const questInfoView = new ViewCtor(quest, options, this);
    iconView.addChild(questInfoView);

    addCleaner(questInfoView, () => {
        if (this.activeInfoView === questInfoView) {
            delete this.activeInfoView;
        }
    });

    this.activeInfoView = questInfoView;
};

QuestsIcon.prototype.resetState = function () {
    this.available = Map2dLocation.currentLocation && Map2dLocation.currentLocation.quests && Map2dLocation.currentLocation.quests.config && cleverapps.meta.selectedLocationId() !== "collections" && QuestsWindow.IsAvailable();
    if (this.available) {
        this.setAttention(Map2dLocation.currentLocation.quests.hasAttention());
    }
};

QuestsIcon.prototype.clearListeners = cleverapps.extendFunc(QuestsIcon.prototype.clearListeners, function (...args) {
    this._super(...args);

    runCleaners(this);
});
